'use client';

import { useTranslationStore } from '../../../../stores';
import { InputHTMLAttributes } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation as t } from '../../../../hooks/useTranslation';
import clsx from 'clsx';

interface EpCheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  errorMessage?: string;
  checkboxValue: string;
  checkboxName: string;
  checkboxLabel: string;
  required?: boolean;
  checkboxWithError?: boolean;
}

export const EpCheckbox = ({
  errorMessage = '* Required Fied',
  checkboxValue,
  checkboxName,
  checkboxLabel,
  required = true,
  checkboxWithError = false,
  ...props
}: EpCheckboxProps) => {
  const { register } = useFormContext();
  const { translations } = useTranslationStore();

  return (
    <div className="ep-radio-button">
      <input
        {...register(`${checkboxName}.inputValue` as const, {
          required: {
            value: required,
            message: t(translations['global'], errorMessage),
          },
        })}
        className={clsx(
          'form-check-input',
          checkboxWithError && 'ep-radio-button--with-error'
        )}
        type="checkbox"
        id={`${checkboxName}.${checkboxValue}`}
        value={checkboxValue}
        style={{ marginRight: '8px' }}
        {...props}
      />

      <label
        htmlFor={`${checkboxName}.${checkboxValue}`}
        className="form-check-label ep-radio-button__label"
      >
        <span
          className={clsx(
            'ep-radio-button__label-text',
            checkboxWithError && 'ep-radio-button__label--with-error'
          )}
        >
          {checkboxLabel}
        </span>
      </label>
    </div>
  );
};
